import Vue from 'vue'
import VueRouter from 'vue-router'
import Header from '../components/Header'
import Index from '../components/Index'
import Number from '../components/Number'
import Point from '../components/Point'
import Test from '../components/Test'
import Sig from '../components/Sig'
import Member from '../components/Member'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'




Vue.use(VueRouter)

export default new VueRouter({
  mode:'history',
  routes: [
    {
      path: '/',
      redirect:'/index'
    },
    {
      path: '/number',
      name: 'Number',
      component: Number
    },
    {
      path: '/sig',
      name: 'Sig',
      component: Sig
    },
    {
      path: '/member',
      name: 'Member',
      component: Member
    },
    {
      path: '/index',
      name: 'Index',
      component: Index
    },
    {
      path: '/point',
      name: 'Point',
      component: Point
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js